import { tokenAtom } from '@/atoms/auth';
import { jotaiStore } from '@/atoms/store';
import { baseUrl } from '@/constants';

export class ApiError extends Error {
    status: number;
    data: { message: string; [key: string]: unknown };
    constructor(status: number, responseBody: { message: string; [key: string]: unknown }) {
        super(responseBody.message || 'API Error');
        this.status = status;
        this.data = responseBody;
    }
}

export async function request<T>(endpoint: string, options: RequestInit = {}): Promise<T> {
    const token = jotaiStore.get(tokenAtom);

    const isFormData = options.body instanceof FormData;
    const headers: HeadersInit = {
        ...(!isFormData && { 'Content-Type': 'application/json' }),
        ...(token && { Authorization: `Bearer ${token}` }),
    };

    const response = await fetch(`${baseUrl}${endpoint}`, {
        ...options,
        headers: { ...headers, ...(options.headers as Record<string, string>) },
    });

    if (!response.ok) {
        const body = await response.json().catch(() => ({ message: `API Error: ${response.status} ${response.statusText}` }));
        throw new ApiError(response.status, body);
    }
    return response.json();
}
